import React from "react";

import { type GetCampaign_me_adObject } from "@north-beam/nb-client-side";

import { type Level } from "../../types";

import { TableSection } from "./table-section";
import { TopLevel } from "./top-level";

interface Props {
  adObject: GetCampaign_me_adObject;
  adObjectLevel: Level;
  onChangeAdObject(id: string): void;
}

export const Performance = ({
  adObject,
  adObjectLevel,
  onChangeAdObject,
}: Props) => {
  return (
    <>
      <TopLevel adObjectLevel={adObjectLevel} topLevel={adObject.topLevel} />
      {adObjectLevel !== "ad" && (
        <TableSection
          adObject={adObject}
          adObjectLevel={adObjectLevel}
          onClickAdObject={onChangeAdObject}
        />
      )}
    </>
  );
};
